// Next Diamonds — Shopify Inbox chat → 70vh bottom-sheet on mobile
// -----------------------------------------------------------------
// Shopify Inbox renders the chat as a custom element <inbox-online-store-chat
// id="ShopifyChat"> with an OPEN shadow DOM (not an iframe). When opened on
// mobile the host goes position:fixed; inset:0 (fullscreen).
//
// This makes it a 70vh bottom sheet with a tap-to-close scrim above it:
//   - captures Shopify's genuine bubble inline style ONCE (while closed) and
//     restores it exactly on close — never piecemeal-strips it (doing so once
//     dropped the bubble off-screen);
//   - applies drawer styles to the host only while OPEN on mobile;
//   - injects a shadow <style> so the inner panel fills 100% of the 70vh host;
//   - shows a dimmed backdrop over the top ~30%. Tapping it CLOSES the chat
//     (via Shopify's own close button) and blocks clicks reaching the page
//     behind.
// Verified live (Playwright, 390x844). Touches only the chat widget.

(function () {
  'use strict';

  var MOBILE_BP = 767;
  var SHADOW_STYLE_ID = 'nd-chat-drawer-style';
  var BACKDROP_ID = 'nd-chat-backdrop';
  var DRAWER = {
    'position': 'fixed', 'top': 'auto', 'bottom': '0', 'left': '0', 'right': '0',
    'height': '70vh', 'max-height': '70vh', 'width': '100vw', 'max-width': '100vw',
    'border-radius': '16px 16px 0 0', 'overflow': 'hidden',
    'box-shadow': '0 -8px 32px rgba(0,0,0,.22)', 'z-index': '2147483647'
  };

  var bubbleStyle = null;     // Shopify's genuine host inline style while closed (bubble)
  var appliedDrawer = false;  // true only while WE have the mobile drawer applied
  var backdrop = null;

  function isMobile() { return window.innerWidth <= MOBILE_BP; }
  function host() { return document.getElementById('ShopifyChat'); }
  function isOpen(h) { var r = h && h.shadowRoot; return !!(r && r.querySelector('.chat-app--is-open')); }

  function injectShadowStyle(h) {
    var r = h && h.shadowRoot;
    if (!r || r.getElementById(SHADOW_STYLE_ID)) return;
    var st = document.createElement('style');
    st.id = SHADOW_STYLE_ID;
    // Make the chat fill the 70vh host as a flex column so the message list
    // scrolls and the composer (input bar) stays pinned + visible. Targets BOTH
    // views: interstitial (.chat-ui.is-mobile) and conversation
    // (.chat-ui.chat-view.chat-ui--is-mobile) — hence the broad .chat-ui.
    st.textContent =
      '@media (max-width:767px){' +
        '.chat-app,.chat-app--is-open,.chat-app--is-open>div,.chat-ui{' +
          'height:100%!important;max-height:100%!important;min-height:0!important;}' +
        '.chat-ui{display:flex!important;flex-direction:column!important;overflow:hidden!important;}' +
        '.chat-main-body{flex:1 1 auto!important;min-height:0!important;}' +
        '.chat-messages{flex:1 1 auto!important;min-height:0!important;}' +
        '.composer-bar-wrapper{flex:0 0 auto!important;}' +
        '.chat-app--is-open{border-radius:16px 16px 0 0!important;overflow:hidden!important;}' +
      '}';
    r.appendChild(st);
  }

  function applyDrawer(h) { var s = h.style; for (var k in DRAWER) s.setProperty(k, DRAWER[k], 'important'); }
  function captureBubble(h) { if (bubbleStyle === null && !isOpen(h)) bubbleStyle = h.getAttribute('style') || ''; }

  function closeChat(h) {
    var r = h && h.shadowRoot;
    var btn = r && (r.querySelector('button[aria-label="Close chat window"]') || r.querySelector('button[aria-label*="close" i]'));
    if (btn) btn.click();
  }

  function showBackdrop(h) {
    if (backdrop && backdrop.parentNode) return;
    backdrop = document.createElement('div');
    backdrop.id = BACKDROP_ID;
    backdrop.style.cssText =
      'position:fixed;inset:0;background:rgba(0,0,0,.32);z-index:2147483646;' +
      'opacity:0;transition:opacity .2s ease;-webkit-tap-highlight-color:transparent;cursor:pointer;';
    // Tap anywhere on the scrim (the exposed top ~30%) closes the chat and
    // never reaches the page behind (the scrim is the click target).
    backdrop.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); closeChat(h); });
    document.body.appendChild(backdrop);
    backdrop.getBoundingClientRect(); // reflow so the fade-in runs
    backdrop.style.opacity = '1';
  }

  function hideBackdrop() {
    if (!backdrop) return;
    var b = backdrop; backdrop = null;
    b.style.opacity = '0';
    setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, 220);
  }

  function update() {
    var h = host(); if (!h) return;
    injectShadowStyle(h); // shadow rules are @media(max-width:767px) — inert on desktop
    if (isMobile() && isOpen(h)) {
      captureBubble(h);
      applyDrawer(h);
      showBackdrop(h);
      appliedDrawer = true;
    } else {
      hideBackdrop();
      // Only revert what WE applied. On desktop (or a never-applied bubble) we
      // never touch the host, so Shopify fully owns it — no tug-of-war.
      if (appliedDrawer) {
        if (bubbleStyle !== null) h.setAttribute('style', bubbleStyle);
        appliedDrawer = false;
      }
      captureBubble(h);
    }
  }

  var shadowObserver = null;
  function watchShadow(h) {
    if (shadowObserver || !h || !h.shadowRoot) return;
    shadowObserver = new MutationObserver(update);
    shadowObserver.observe(h.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  function boot() {
    var h = host();
    if (h) { captureBubble(h); injectShadowStyle(h); watchShadow(h); update(); }
  }

  if (document.body) {
    new MutationObserver(function () {
      var h = host();
      if (h) { captureBubble(h); watchShadow(h); update(); }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  [400, 1000, 2000, 3500, 5000].forEach(function (t) { setTimeout(boot, t); });

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(update, 120); });
})();
